export default {
  user: {}
};
